import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Achievements from '../components/Achievements';

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Projects />
      <Achievements />
    </div>
  );
};

export default Home;